<template>
  <div class="addressdetails">
      <div class="text-xs-left subheading font-weight-bold ">Delivery Address</div>
      <AddressInput ref="address" v-model="address" ></AddressInput>
  </div>
</template>

<script>
import {mapState} from 'vuex'
// import utils from '../../../utils.ts'
import AddressInput from '../../common/AddressInput'

export default {
  name: 'AddressDetails',
  components: {
    AddressInput
  },
  data: function () {
    return {
      address: {}
    }
  },
  computed: {
    ...mapState({
      deliveryAddress: state => state.cart.deliveryAddress
    })
  },
  watch: {
    address: function (addr) {
      this.saveToCart()
    }
  },
  mounted: function () {
    if (this.deliveryAddress) {
      this.address = this.deliveryAddress
    }
  },
  methods: {
    saveToCart: function () {
      // Save the current form settings to the cart
      return this.$store.dispatch('cart/setDeliveryAddress', this.address)
    },
    getData: function () {
      // Returns the form data
      return this.address
    },
    isValid: function () {
      return this.$refs['address'].isValid()
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
